export class AdminTabsEnum {
  static RIGHTS = '/administration';
  static CHANNEL_ACCESS = '/channel-access';
  static START_CHANNEL = '/start-channel';
}
